import { useCallback, useEffect, useState } from "react";

export const useMemberDeactivated = (communityMemberId?: number) => {
  const [isDeactivated, setIsDeactivated] = useState(false);

  useEffect(() => {
    setIsDeactivated(false);
  }, [communityMemberId]);

  const onMemberDeactivatedEvent = useCallback((eventData: any) => {
    if (eventData.event === "memberDeactivated") {
      setIsDeactivated(true);
    }
  }, []);

  return { isDeactivated, onMemberDeactivatedEvent };
};
